import { Box, DialogHeader } from '@ff-it/ui';
import { openPlanModal } from '../../../openPlanModal';
import { DialogForm } from 'components';
import type { PlanRow, Position } from 'modules/campaign/row';
import { PositionDialog } from './PositionDialog';
import type { SelectionState } from '../types';
import { PlanResolution } from 'modules/campaign/plan/types';
import { formatInterval } from 'utilities';
import { PlanMutations } from 'modules/campaign/plan/state/mutate';
import invariant from 'tiny-invariant';
import { formatISO } from 'date-fns';
import { insertPosition } from './helpers';
import { InlineItem } from 'components/form/types';
import type { Interval } from 'core/types';

export async function openPositionDialog(
  row: PlanRow,
  interval: Interval,
  resolution: PlanResolution,
  update: PlanMutations['update'],
  requestHandler: PlanMutations['requestHandler'],
  selection: SelectionState,
) {
  let initialPositions: InlineItem<Position>[] = row.positions;
  let initialActiveKey: string;
  if (selection) {
    invariant(!selection.error);

    if (selection.type === 'selection') {
      const date_from = formatISO(selection.start, { representation: 'date' });
      const date_to = formatISO(selection.end, { representation: 'date' });
      [initialPositions, initialActiveKey] = insertPosition({ date_from, date_to, quantity: null }, row.positions);
    } else if (selection.type === 'segment') {
      // select existing position
      initialActiveKey = `position-${selection.id}`;
    }
  }

  await openPlanModal(
    (props) => (
      <DialogForm
        {...props}
        initialValues={{ positions: initialPositions }}
        submitHandler={async ({ positions }) => {
          const res = await update({ rows: { upsert: [{ id: row.id, positions: positions || [] }] } });
          const err = res.unwrapFormError();
          if (err && !err['non_field_errors']) {
            return { positions: err };
          }
          return err;
        }}
        header={
          <DialogHeader title="Positions">
            <Box textSize="xs" color="secondary" ml="auto">
              {formatInterval(interval.start, interval.end)}
            </Box>
          </DialogHeader>
        }
      >
        <PositionDialog
          rowId={row.id}
          requestHandler={requestHandler}
          interval={interval}
          resolution={resolution}
          initialActiveKey={initialActiveKey}
        />
      </DialogForm>
    ),
    { testId: 'positions', initialFocus: -1, dismissProps: { outsidePress: false } },
  );
}
